import { render } from "./AdjustInventory.vue?vue&type=template&id=4cd4c879&scoped=true"
import script from "./AdjustInventory.vue?vue&type=script&lang=js"
export * from "./AdjustInventory.vue?vue&type=script&lang=js"

import "./AdjustInventory.vue?vue&type=style&index=0&id=4cd4c879&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd4c879"]])

export default __exports__